import { Stack, Typography, useTheme } from '@mui/material';
import { CaretDown } from '@phosphor-icons/react';

import { Divider } from 'theSource/components/Divider';
import { Spacer } from 'theSource/components/Spacer';
import {
  AccordionDetailsStyled,
  AccordionStyled,
  AccordionSummaryStyled,
} from './AccordionStyled';

export interface AccordionProps {
  label: string;
  children?: JSX.Element | JSX.Element[];
  startIcon?: JSX.Element;
  testId?: string;
  defaultExpanded?: boolean;
}

export const Accordion = ({
  label,
  children,
  startIcon,
  testId = 'accordion',
  defaultExpanded = false,
}: AccordionProps) => {
  const theme = useTheme();
  return (
    <AccordionStyled
      data-testid={testId}
      defaultExpanded={defaultExpanded}
      disableGutters
    >
      <AccordionSummaryStyled
        expandIcon={<CaretDown size={20} weight="bold" />}
        $startIcon={Boolean(startIcon)}
      >
        {startIcon && (
          <>
            {startIcon}
            <Spacer width={5} />
          </>
        )}

        <Typography variant="body2Heading">{label}</Typography>
      </AccordionSummaryStyled>
      <Divider />
      <AccordionDetailsStyled>
        <Spacer height={3} />
        <Stack spacing={theme.spacing(4)}>{children}</Stack>
        <Spacer height={3} />
      </AccordionDetailsStyled>
    </AccordionStyled>
  );
};
